import { FaUser,  FaShoppingBasket } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';

const MenuAdministrativosRei = () => {

return (
    <div className="card">
        <div className="card-header">
            <h2>Menu Reincorporados</h2>
        </div>
        <div className="card-body">
            <div className="row">
                <div>
                    <NavLink to={'/reincorporados/informes/personas'} 
                        className="btn btn-app bg-primary" 
                        data-tooltip-id="tooltiparriba"
                        data-tooltip-content="Personas por fecha de creación">
                        <FaUser size={20} color="black" /> Personas
                    </NavLink> 
                    <NavLink to={'/reincorporados/informes/familias'} 
                        className="btn btn-app bg-primary" 
                        data-tooltip-id="tooltiparriba"
                        data-tooltip-content="Familias">
                        <FaUser size={20} color="black" /> Familias
                    </NavLink>
                    <NavLink to={'/reincorporados/informes/atenciones'} 
                        className="btn btn-app bg-primary" 
                        data-tooltip-id="tooltiparriba"
                        data-tooltip-content="Atenciones">
                        <FaShoppingBasket size={20} color="black" /> Atenciones
                    </NavLink>
                </div>                
            </div>
        </div>
    {/* /.card-body */}
    </div>
);
};

export default MenuAdministrativosRei;